<template>
  <div>
    <ul class="nav nav-tabs mb-4">
      <li class="nav-item">
        <div class="nav-link active">Failed Payments</div>
      </li>
    </ul>
    <DatatableReportV3
      id="failed-payments-table"
      :source="source"
      :config="config"
      :filters="filters"
      :no-download="true"
    />
  </div>
</template>

<script>
import { companyNameColumns } from "@/lib/customerTypes";

import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";
import ManualRetryButton from "@/Reports/ManualRetryButton.vue";
import store from "@/vuex/store";

export default {
  components: {
    DatatableReportV3
  },
  props: {
    source: {
      type: String,
      default: ""
    },
    filters: {
      type: Array,
      default: () => []
    }
  },
  data() {
    // The default sort is by position, so it moves with the Company Name
    // column to stay on the same column.
    const companyColumns = companyNameColumns();

    return {
      config: {
        responsive: true,
        order: [[companyColumns.length, "asc"]],
        columns: [
          ...companyColumns,
          { data: "customer", title: "Customer", responsivePriority: 1 },
          {
            data: "address",
            responsivePriority: 9,
            title: "Address",
            searchable: false,
            orderable: false
          },
          {
            data: "program",
            responsivePriority: 8,
            title: "Membership Program",
            searchable: false,
            orderable: false
          },
          {
            data: "renewal_date",
            title: "Renewal Date",
            searchable: false,
            responsivePriority: 6
          },
          {
            data: "amount",
            title: "Amount",
            searchable: false,
            responsivePriority: 2
          },
          { data: "invoice", title: "Invoice", responsivePriority: 3 },
          {
            data: "card",
            responsivePriority: 7,
            title: "Card",
            searchable: false,
            orderable: false
          },
          {
            data: "last_attempt",
            title: "Last Attempt",
            searchable: false,
            responsivePriority: 5
          },
          {
            data: "auto_retry_status",
            responsivePriority: 4,
            title: "Auto Retry Status",
            className: "wrap-when-collapsed",
            searchable: false,
            orderable: false
          },
          {
            data: "actions",
            title: "",
            searchable: false,
            orderable: false,
            className: "text-center"
          }
        ],
        vueComponents: [
          {
            rootId: "manual-retry-button-vue",
            component: ManualRetryButton,
            options: { store }
          }
        ]
      }
    };
  }
};
</script>

<style>
#failed-payments-table tr.retry-highlighted,
#failed-payments-table tr.retry-highlighted:hover,
#failed-payments-table tr.retry-highlighted td {
  background-color: #d4edda !important;
}
</style>
